// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a28e2471","239":"09442809","455":"9eabcbd3"}[chunkId] + ".chunk.js";
};